import { render, staticRenderFns } from "./UserHistory.vue?vue&type=template&id=58b29e5c&scoped=true"
import script from "./UserHistory.vue?vue&type=script&lang=js"
export * from "./UserHistory.vue?vue&type=script&lang=js"
import style0 from "./UserHistory.vue?vue&type=style&index=0&id=58b29e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b29e5c",
  null
  
)

export default component.exports